/**
 * First, we will load all of this project's Javascript utilities and other
 * dependencies. Then, we will be ready to develop a robust and powerful
 * application frontend using useful Laravel and JavaScript libraries.
 */
//import "./bootstrap";
import Vue from "vue";
import VModal from "vue-js-modal";
import VueFloatLabel from "vue-float-label";
// Polyfill for promises within IE11/older unsupported browsers
import "promise-polyfill/src/polyfill";
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
// Require everything withing the /components directory as a Vue component
var files = require.context("./", true, /\.vue$/i);
files.keys().map(function (key) {
    var _a, _b;
    return Vue.component((_b = (_a = key
        .split("/")
        .pop()) === null || _a === void 0 ? void 0 : _a.split(".")[0], (_b !== null && _b !== void 0 ? _b : "")), files(key)["default"]);
});
// Create new instance of view on #app elements
new Vue({
    el: "#app"
});
Vue.use(VModal);
// https://www.npmjs.com/package/vue-float-label
Vue.use(VueFloatLabel);
